// @flow

export const SET_PERMISSION = 'location/SET_PERMISSION';

export function setPermission(permission) {
  return {
    type: SET_PERMISSION,
    permission,
  };
}



// WEBPACK FOOTER //
// ./actions/locationPermission.js